import React, {FC, forwardRef, useCallback, useEffect, useState} from 'react';

import {cn} from '@bem-react/classname';
import {ArrowRotateRight} from '@gravity-ui/icons';
import {Button, Card, Text, TextInput} from '@gravity-ui/uikit';
import {Captcha} from 'common/models/survey';

import {CaptchaQuestionProps} from './CaptchaQuestion.types';

import './CaptchaQuestion.scss';

const {mobile} = window.YC;

const cnCaptchaQuestion = cn('CaptchaQuestion');

const CaptchaQuestion: FC<CaptchaQuestionProps> = forwardRef<HTMLDivElement, CaptchaQuestionProps>(
    function CaptchaQuestion(
        {
            url: initialUrl,
            label,
            captchaKey: initialKey,
            refreshCaptcha,
            onUpdate: onUpdateBase,
            className,
            error,
            value,
        },
        ref,
    ) {
        const [key, setKey] = useState(initialKey);
        const [url, setUrl] = useState(initialUrl);

        const onRefreshCaptcha = useCallback(() => {
            refreshCaptcha().then((result: Captcha) => {
                setKey(result.key);
                setUrl(result.image_url);
            });
        }, [refreshCaptcha]);

        const onUpdate = useCallback(
            (text: string) => {
                if (onUpdateBase) {
                    onUpdateBase({value: text, key});
                }
            },
            [key, onUpdateBase],
        );

        useEffect(() => {
            if (error) {
                onRefreshCaptcha();
            }
        }, [error, onRefreshCaptcha]);

        return (
            <Card className={cnCaptchaQuestion('', [className])} ref={ref}>
                <div className={cnCaptchaQuestion('ImageWrapper', {mobile})}>
                    <img src={url} className={cnCaptchaQuestion('Image')} alt="" />
                </div>
                <div className={cnCaptchaQuestion('LabelWrapper')}>
                    <Text variant="body-2" as="div">
                        {label}
                    </Text>
                    <Button
                        view="flat-secondary"
                        onClick={onRefreshCaptcha}
                        className={cnCaptchaQuestion('Refresh')}
                    >
                        <Button.Icon>
                            <ArrowRotateRight width={21} height={21} />
                        </Button.Icon>
                    </Button>
                </div>
                <TextInput
                    size="l"
                    onUpdate={onUpdate}
                    value={value}
                    className={cnCaptchaQuestion('Input')}
                    controlProps={{className: cnCaptchaQuestion('InputControl')}}
                />
                {error && (
                    <Text variant="body-1" color="danger" className={cnCaptchaQuestion('Error')}>
                        {error}
                    </Text>
                )}
            </Card>
        );
    },
);

export default CaptchaQuestion;
